import React, { useState } from "react";
import styles from "./SupervisorOrderHistory.module.css";
import StepsComponent from "../../../../../../components/StepsComponent/StepsComponent";
import SubmitButton from "../../../../../../components/submitButton/SubmitButton";
import TextComponent from "../../../../../../components/textComponent/TextComponent";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";



const OrderHistoryComponent = () => {
    const navigate = useNavigate();

    const columns = [
        {
            title: "Order ID",
            dataIndex: "OrderID",
            key: "OrderID",
        },
        
        {
            title: "Lot No",
            key: "LotNo",
            dataIndex: "LotNo",
        },
        {
            title: "Order Date",
            dataIndex: "OrderDate",
            key: "OrderDate",
        },
        {
            title: "Lot size",
            key: "Lotsize",
            dataIndex: "Lotsize",
        },
        {
            title: "Lot Used",
            key: "LotUsed",
            dataIndex: "LotUsed",
        },
        {
            title: "Fulfillment Status",
            key: "FulfillmentStatus",
            dataIndex: "FulfillmentStatus",
        },
        {
            title: "",
            key: "action",
            dataIndex: "Button",
            render: (text, record) => record.Button,
        },

    ];

    const data = [
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            LotNo: "#123",
            Lotsize: "50 kg",
            LotUsed: "30 kg",
            FulfillmentStatus: "Delivered",
            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                    onClick={() => navigate("/Warehouse/SupervisorProductJourney")}

                />
        },
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            LotNo: "#123",
            Lotsize: "40 kg",
            LotUsed: "10 kg",
            FulfillmentStatus: "Delivered",
            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                // onClick={handleSubmit}
                />
        },
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            LotNo: "#123",
            Lotsize: "30 kg",
            LotUsed: "05 kg",
            FulfillmentStatus: "Delivered",
            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                // onClick={handleSubmit}
                />
        },
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            LotNo: "#123",
            Lotsize: "20 kg",
            LotUsed: "15 kg",
            FulfillmentStatus: "Delivered",
            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                // onClick={handleSubmit}
                />
        },
        {
            OrderID: "153534",
            OrderDate: "Aug 13, 2025 ",
            LotNo: "#123",
            Lotsize: "10 kg",
            LotUsed: "05 kg",
            FulfillmentStatus: "Delivered",
            Button:
                <SubmitButton
                    title={"View"}
                    primary
                    btnClass={styles.actionBtn}
                // onClick={handleSubmit}
                />
        },

    ];

    return (
        <div className={styles.mainCont}>

            <div className={styles.TableDiv}>
                <Table
                    scroll={{ x: true }}
                    columns={columns}
                    dataSource={data}
                    pagination={false}
                    rowKey="No"
                />
            </div>

        </div>
    );
};

export default OrderHistoryComponent;
